import React, { FC }                           from "react";
import { useDrag }                             from "react-dnd";
import { useDispatch }                         from "react-redux";
import { Button, Card, Form, Input, TextArea } from "semantic-ui-react";
import RecordTemplateRepository                from "../../../../../domain/record/template/RecordTemplateRepository";
import WidgetTitle                             from "../../../../../domain/record/widget/WidgetTitle";
import WidgetType                              from "../../../../../domain/record/widget/WidgetType";
import RecordTemplateDataSource
                                               from "../../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import WidgetProps                             from "../WidgetProps";

const DropAreaTextAreaLargeWidget: FC<WidgetProps> = (props: WidgetProps) => {
  const repository: RecordTemplateRepository = new RecordTemplateDataSource(useDispatch());
  const [{isDragging}, drag] = useDrag({
    item: {widgetIndex: props.widgetIndex, type: WidgetType.TEXT_AREA_LARGE},
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  const {widgetIndex, widget} = props;
  return (
    <>
      <div
        ref={ drag }
        style={ {
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
          position: "absolute",
          left: widget.coordinate.x + "px",
          top: widget.coordinate.y + "px"
        } }
      >
        <Card style={ {width: "460px"} }>
          <Card.Content>
            <Card.Header>
              <Input
                style={ {height: "33.5px", width: "385px"} }
                defaultValue={ widget.title.value }
                onChange={ (event, data) => repository.setWidgetTitle(widgetIndex, new WidgetTitle(data.value)) }
                placeholder="タイトルを入力"
              />
              <Button
                style={ {height: "33.5px", marginLeft: "5px"} }
                icon="close"
                onClick={ () => repository.deleteWidget(widgetIndex) }
              />
            </Card.Header>
            <Form>
              <TextArea
                style={ {resize: "none", height: "400px", backgroundColor: "#E9ECEF"} }
                disabled
              />
            </Form>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default DropAreaTextAreaLargeWidget;
